<div class="dsm-flex-container video {{textStyle}}" [ngStyle]="{'background-color': backgroundColor}">
    <div class="flex-row">
        <div class="video-content-wrapper">
            <div class="video-embed" [innerHTML]="embedLink | safeHtml">
            </div>
            <div>
                <h2 class="heading-2">{{translationRoot + '.title' | translate:useLocaleOverride}}</h2>
                <p>{{translationRoot + '.body' | translate:useLocaleOverride}}</p>
            </div>
        </div>
    </div>
</div>
